import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { customersApi } from '../../services/api';
import { formatCustomerName } from '../../utils/formatCustomerName';

export default function BankCustomerSearch({ value, onChange, active = true, label = 'Cliente', sx }) {
  const [input, setInput] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    let current = true;
    setOptions([]); setError(false); setLoading(false);
    if (!active || input.trim().length < 2) return;
    const timer = setTimeout(async () => {
      setLoading(true);
      const compact = input.replace(/[\s-]/g, '').toUpperCase();
      const search = /^(?:[A-Z]{6}[A-Z0-9]{10}|\d{11})$/.test(compact) ? compact : input.trim();
      try {
        const response = await customersApi.getAll({ search, limit: 20 });
        if (current) setOptions(response.data?.data || []);
      } catch {
        if (current) setError(true);
      } finally {
        if (current) setLoading(false);
      }
    }, 250);
    return () => { current = false; clearTimeout(timer); };
  }, [input, active]);
  useEffect(() => { if (!active) setInput(''); }, [active]);
  return <Autocomplete
    sx={sx} options={options} loading={loading} value={value}
    isOptionEqualToValue={(a, b) => a.id === b.id}
    getOptionLabel={option => `${option.cod_cli || ''} - ${formatCustomerName(option, '')}`}
    // The server also searches tax codes and meters, which are absent from the display label.
    filterOptions={results => results}
    onChange={(_, customer) => { setInput(''); onChange(customer); }}
    onInputChange={(_, text, reason) => setInput(reason === 'reset' ? '' : text)}
    noOptionsText={input.trim().length < 2 ? 'Digita almeno 2 caratteri' : 'Nessun cliente trovato'}
    renderInput={params => <TextField {...params} label={label} error={error}
      placeholder="Nome, codice cliente, codice fiscale o contatore"
      helperText={error ? 'Ricerca non riuscita. Riprova.' : 'Cerca anche per codice fiscale completo o parziale'} />}
    renderOption={(props, option) => <li {...props} key={option.id}><Box>
      <Typography variant="body2"><strong>{option.cod_cli}</strong> - {formatCustomerName(option, '')}</Typography>
      {option.codice_fiscale && <Typography variant="caption" display="block">CF: {option.codice_fiscale}</Typography>}
      {option.citta && <Typography variant="caption" color="text.secondary">{option.citta} {option.provincia && `(${option.provincia})`}</Typography>}
    </Box></li>} />;
}
